module.exports = __webpack_public_path__ + "img/order_banner@2x.ec87443f.png";